// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XDFgc35Qw7Bja2 {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.H9SJKdZvdVfHS0 {
  display: flex;
  justify-content: center;
}
.YC2k1YWj1Au4BZ {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.qdLbWl4HLgnCEj {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.ZrVmDVhmzPS1nd {
  font-style: italic;
}
.KFxZiDDIWMrFb7 {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.zlNDWdRFSGqQW_ {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bR7v7KcWjnGLXE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.bR7v7KcWjnGLXE .D9ME8UUm6K8lQQ {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.pILGxLvNoK4tKL {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.pILGxLvNoK4tKL button {
  margin-left: var(--ds-space-100, 8px);
}
.XwKylodFigNkHt {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .KFxZiDDIWMrFb7 {
    padding: var(--ds-space-200, 16px);
  }
}
.mYRwz66Hj0j7Mf label {
  display: block;
  margin-bottom: var(--ds-space-050, 4px);
}
.Tpm8hHvAPgXxNu {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: var(--ds-space-250, 20px);
  margin-bottom: var(--ds-space-100, 8px);
}
.ij4FC48ME9fvFR {
  width: 36px;
  height: 36px;
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0) var(--ds-space-0, 0) 10px;
  padding: var(--ds-space-0, 0);
}
.vUd2p2BqTOLDCi {
  flex-grow: 1;
  margin-top: 11px;
  margin-left: 45px;
}
.GfQy6be1NCGYTl {
  margin-top: var(--ds-space-0, 0);
}
.zlNDWdRFSGqQW_ {
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .Tpm8hHvAPgXxNu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .vUd2p2BqTOLDCi {
    max-width: 400px;
    margin-left: var(--ds-space-0, 0);
    color: var(--ds-text-subtle, #44546f);
  }
}
.XZD7HbrSoSGDLX {
  height: 50px;
}
.RPR0yO8sZ08bvr {
  margin-right: 18px;
  margin-left: var(--ds-space-100, 8px);
}
.SymxIJOynQFGfv {
  display: flex;
  position: absolute;
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  align-items: center;
  justify-content: flex-end;
  min-width: 100%;
  height: 64px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `XDFgc35Qw7Bja2`,
	"flexAndCenter": `H9SJKdZvdVfHS0`,
	"body": `YC2k1YWj1Au4BZ`,
	"navigationAndContent": `qdLbWl4HLgnCEj`,
	"learnMoreSubtle": `ZrVmDVhmzPS1nd`,
	"content": `KFxZiDDIWMrFb7`,
	"spinnerContainer": `zlNDWdRFSGqQW_`,
	"header": `bR7v7KcWjnGLXE`,
	"title": `D9ME8UUm6K8lQQ`,
	"footer": `pILGxLvNoK4tKL`,
	"formFooter": `XwKylodFigNkHt`,
	"formElements": `mYRwz66Hj0j7Mf`,
	"formSection": `Tpm8hHvAPgXxNu`,
	"copyBtn": `ij4FC48ME9fvFR`,
	"inputDescription": `vUd2p2BqTOLDCi`,
	"label": `GfQy6be1NCGYTl`,
	"modalHeader": `XZD7HbrSoSGDLX`,
	"generateBtn": `RPR0yO8sZ08bvr`,
	"modalFooter": `SymxIJOynQFGfv`
};
export default ___CSS_LOADER_EXPORT___;
